export default __webpack_public_path__ + "static/media/tts_en_jing_b3(-10).ac046186.mp3";